import { BodyFileNodeView } from "@/components/rich-editor/components/BodyFileNodeView.tsx";
import { dataAttribute } from "@/components/rich-editor/extensions/body-file-node.helpers.ts";
import { mergeAttributes, Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

export const Video = Node.create({
  name: "video",
  group: "block",
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      fileUuid: dataAttribute("fileUuid", "data-file-uuid"),
      src: dataAttribute("src", "data-src"),
      fileName: dataAttribute("fileName", "data-file-name"),
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="video"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes({ "data-type": "video" }, HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(BodyFileNodeView);
  },
});
